export const validationRules = {
    First_Name: {
            required: true,
            pattern: /^[A-Za-z\s]+$/,
            message: "First Name must contain only letters.",
            maxLength: 19,
            maxLengthMessage: "First Name must contain lessthan 20 characters."
        },
        Last_Name: {
            required: true,
            pattern: /^[A-Za-z\s]+$/,
            message: "Last Name must contain only letters.",
            maxLength: 19,
            maxLengthMessage: "Last Name must contain lessthan 20 characters."
        },
        Address: {
            required: true,
            minLength: 5,
            maxLength: 100,
            message: "Address must be between 5 and 100 characters."
        },
        City: {
            required: true,
            pattern: /^[A-Za-z\s]+$/,
            message: "City must contain only letters."
        },
        Zip_Code: {
            required: true,
            pattern: /^(?:\d{5}|\d{5}-\d{4})$/,
            message: "Enter a valid ZIP code (e.g., 12345 or 12345-6789)."
        },
        State: {
            required: true,
            message: "Please select a State."
        }
        ,
        Phone_Number: {
            required: true,
            pattern: /^[0-9]{10}$/,
            message: "Enter valid phone number.",
            maxLength: 10,
            maxLengthMessage: "Phone Number must not exceed 10 digits."
        },
        Email_Address: {
            required: true,
            pattern: /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
            message: "Please enter a valid Email Address."
        },
    name: {
        pattern: /^[a-zA-Z\s]{3,50}$/,
        message: "Name must contain only letters and be between 3-50 characters.",
    },
    email: {
        pattern: /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
        message: "Enter a valid Email Address.",
    },
    phone: {
        pattern: /^[0-9]{10}$/,
        message: "Enter a valid 10-digit Phone Number.",
    },
    Date_of_birth: {
        required: false,
        validate: (value) => {
            // Ensure the format is YYYY-MM-DD
            const regex = /^\d{4}-\d{2}-\d{2}$/;
            if (!regex.test(value)) {
                return "Enter a valid date in YYYY-MM-DD format.";
            }

            // Convert input to a Date object
            const enteredDate = new Date(value);
           
            const minValidDate = new Date("1900-01-01"); // The earliest allowed date
            const maxValidDate = new Date("2007-12-31"); // The latest allowed date

            // Check if the entered date is out of range
            if (enteredDate < minValidDate) {
                return "Date of birth must be after 1900.";
            }
            if (enteredDate > maxValidDate) {
                return "Date of birth must be before 2008.";
            }

            return ""; // No error if valid
        },
    },


    Social_security: {
        required: false,
        pattern: /^\d{9}$/,
        message: "Enter a valid 9-digit Social Security Number.",
    },
    Credit_card: {
        required: false,
        pattern: /^\d{15,16}$/,
        message: "Enter a valid 15 or 16-digit Credit Card Number.",
    },
    Drivers_license: {
        required: false,
        pattern: /^[A-Za-z0-9]{6,16}$/,
        message: "Enter a valid Driver's License (6-16 alphanumeric characters).",
    },
    Credit_Issue: {
        required: false,
    },

    /*income: {
        pattern: /^\d+(\.\d{1,2})?$/,
        message: "Enter a valid income (numeric, up to 2 decimal places).",
    },*/

    Business_Name: {
        required: true,
        minLength: 2,
        message: "Business Name must be at least 2 characters.",
    },
    Business_Address: {
        required: true,
        minLength: 5,
        maxLength: 100,
        message: "Business Address must be between 5 and 100 characters.",
    },

    _City: {
        required: true,
        pattern: /^[A-Za-z\s]+$/,
        message: "City must contain only letters.",
    },
    _State: {
        required: true,
        message: "Please select a state.",
    },
    _Zipcode: {
        required: true,
        pattern: /^(?:\d{5}|\d{5}-\d{4})$/,
        message: "Enter a valid ZIP code (e.g., 12345 or 12345-6789).",
    },
    Business_phone_number: {
        required: true,
        pattern: /^[0-9]{10}$/,
        message: "Enter a valid 10-digit Phone Number.",
    },
    _EIN: {
        required: true,
        pattern: /^\d{2}-\d{7}$/,
        message: "Invalid EIN format (XX-XXXXXXX).",
    },
    
    _Describe: {
        required: true,
    },
    
    Monthly_income: {
        required: false,
        pattern: /^[1-9]\d{0,7}$/, // Matches 1-8 digit positive numbers
        message: "Monthly Income must be a positive number with up to 8 digits."
    },
    Source_of_income: {
        required: false,
        pattern: /^[A-Za-z\s]+$/,
        message: "Source Of Income must contain only letters and spaces."
    },
    Outstanding_Balance: {
        required: false,
    },
    CVV: {
        required: false,
        pattern: /^[0-9]{3,4}$/,
        message: "CVV must be 3 or 4 digits.",
    },
    Exp: {
        required: false,
        validate: (value) => {
            // Check format MM/YY
            const regex = /^(0[1-9]|1[0-2])\/\d{2}$/;
            if (!regex.test(value)) {
                return "Enter a valid expiry date in MM/YY format.";
            }

            // Get current month and year
            const [month, year] = value.split("/").map(num => parseInt(num, 10));
            const currentYear = new Date().getFullYear() % 100; // Get last 2 digits of the year
            const currentMonth = new Date().getMonth() + 1; // Month is 0-based

            // Check if the expiry date is in the past
            if (year < currentYear || (year === currentYear && month < currentMonth)) {
                return "Expiry date cannot be in the past.";
            }

            return ""; // Return empty string if valid
        },
    },

};
 
// Validate a single field
export const validateField = (name, value) => {
    const rule = validationRules[name];
    if (rule && !rule.pattern.test(value)) {
        return rule.message;
    }
    return "";
};
 
// Validate entire form
export const validateForm = (formData) => {
    const errors = {};
    for (const field in formData) {
        const errorMessage = validateField(field, formData[field]);
        if (errorMessage) {
            errors[field] = errorMessage;
        }
    }
    return errors;
};

    export const handleValidation = (name, value) => {
        const rule = validationRules[name];
        if (!rule) return "";

        // Handle required validation for different field types
        if (rule.required) {
            if (typeof value === "string" && value.trim() === "") {
                return `${name.replace(/_/g, " ")} is required.`; // For text inputs and dropdowns
            }
            if (value === undefined || value === "" || value === null) {
                return `${name.replace(/_/g, " ")} is required.`; 
            }
        }

        // Custom validation function (e.g., date of birth, expiry date check)
        if (rule.validate) {
            const validationMessage = rule.validate(value);
            if (validationMessage) {
                return validationMessage;
            }
        }



        // Pattern validation (only if no custom validate function exists)
        if (rule.pattern && !rule.pattern.test(value)) {
            return rule.message;
        }

        // Min Length validation
        if (rule.minLength && value.length < rule.minLength) {
            return rule.message;
        }

        // Max Length validation
        if (rule.maxLength && value.length > rule.maxLength) {
            return rule.maxLengthMessage; // Use the specific max length message
        }

        return ""; // No error
    };

    export const validateFormOnSubmit = (formData) => {
    const errors = {};
    for (const fieldName in validationRules) {
        const rule = validationRules[fieldName];
        const value = formData[fieldName];

        if (rule.required) {
            if (!value || (typeof value === "string" && value.trim() === "")) {
                errors[fieldName] = `${fieldName.replace(/_/g, " ")} is required.`;
            }
        }
    }
    return errors;
};


